module.exports = __webpack_public_path__ + "img/mso.b5701382.png";